var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('carousel-3d',_vm._l((_vm.bitems),function(item,i){return _c('slide',{key:i,attrs:{"index":i},scopedSlots:_vm._u([{key:"default",fn:function(obj){return [_c('img',{attrs:{"src":item.target}})]}}])})}))],1)}
var staticRenderFns = []

export { render, staticRenderFns }